import {RumPublicApi} from "@datadog/browser-rum-core";

export const initDatadogRum = (datadogRum: RumPublicApi, clientToken: string, version?: string) => {
	const env = getEnvironment();
	const sessionSampleRate = env === "prod" ? 100 : 10;
	const sessionReplaySampleRate = env === "prod" ? 100 : 0;

	datadogRum.init({
		applicationId: "970eccf1-6b6f-436a-a18a-b34d48b82098",
		clientToken,
		// `site` refers to the Datadog site parameter of your organization
		// see https://docs.datadoghq.com/getting_started/site/
		site: "us3.datadoghq.com",
		service: "training-v4-web",
		env,
		sessionSampleRate,
		sessionReplaySampleRate,
		trackUserInteractions: true,
		trackResources: true,
		trackLongTasks: true,
		defaultPrivacyLevel: "mask-user-input",
		allowedTracingUrls: process.env.REACT_APP_API_HOST ? [process.env.REACT_APP_API_HOST] : undefined,
		sessionPersistence: "local-storage",
		version: version
	});
}

export const getEnvironment = () => {
	const API_HOST = process.env.REACT_APP_API_HOST;

	if(API_HOST?.includes("local"))
		return "local";
	if(API_HOST?.includes("dev"))
		return "development";
	if(API_HOST?.includes("qa"))
		return "qa";
	return "prod"
}